"use client";

import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { useClickAway } from "react-use";
export interface NFTLite {
  animation: string | null;
  contract: string;
  icon: string | null;
  id: 1;
  image: string | null;
  name: string | null;
  scaled: string | null;
  thumbnail: string | null;
  artist: string | null;
}
export default function UserSettingsImgSelectMeme(t0) {
  const $ = _c(24);
  const {
    memes,
    onMeme
  } = t0;
  const [input, setInput] = useState("");
  const [filteredMemes, setFilteredMemes] = useState(memes);
  let t1;
  let t2;
  if ($[0] !== input || $[1] !== memes) {
    t1 = () => {
      if (!input) {
        setFilteredMemes(memes);
        return;
      }
      setFilteredMemes(memes.filter(meme => `#${meme.id} ${meme.name}`.toLowerCase().includes(input.toLowerCase())));
    };
    t2 = [input, memes];
    $[0] = input;
    $[1] = memes;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  const [isOpen, setIsOpen] = useState(false);
  const listRef = useRef(null);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsOpen(false);
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  useClickAway(listRef, t3);
  let t4;
  if ($[5] !== onMeme) {
    t4 = meme_0 => {
      onMeme(meme_0);
      setIsOpen(false);
    };
    $[5] = onMeme;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const setMemeAndCloseDropdown = t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <label htmlFor="search-meme" className="tw-block tw-text-sm tw-font-semibold tw-leading-5 tw-text-iron-300">Select Meme</label>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = e => setInput(e.target.value);
    t7 = () => setIsOpen(true);
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  let t8;
  if ($[10] !== input) {
    t8 = <input type="text" name="search-meme" value={input} onChange={t6} onFocus={t7} placeholder="Search" className="tw-appearance-none tw-text-left tw-block tw-w-full tw-rounded-lg tw-border-0 tw-py-3 tw-pl-10 tw-pr-3 tw-bg-iron-900 focus:tw-bg-iron-900 tw-text-iron-50 tw-font-normal tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700 placeholder:tw-text-iron-400 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 hover:tw-ring-iron-600 tw-text-base sm:tw-leading-6 tw-transition tw-duration-300 tw-ease-out" />;
    $[10] = input;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-flex tw-items-center tw-left-3"><svg className="tw-h-5 tw-w-5 tw-text-iron-50" viewBox="0 0 24 24" aria-hidden="true" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></div>;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t8) {
    t10 = <div className="tw-mt-2 tw-relative">{t8}{t9}</div>;
    $[13] = t8;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== filteredMemes || $[16] !== isOpen || $[17] !== setMemeAndCloseDropdown) {
    t11 = isOpen && <motion.div className="tw-origin-top-right tw-absolute tw-right-0 tw-mt-1 tw-w-full tw-rounded-lg tw-shadow-xl tw-bg-iron-800 tw-ring-1 tw-ring-black tw-ring-opacity-5" initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -20
    }} transition={{
      duration: 0.2
    }}><div className="tw-absolute tw-z-10 tw-mt-1 tw-overflow-hidden tw-max-w-full tw-w-full tw-rounded-md tw-bg-iron-900 tw-shadow-2xl tw-ring-1 tw-ring-white/10"><div className="tw-py-1 tw-flow-root tw-max-h-[calc(20rem+_-5vh)] tw-overflow-x-hidden tw-overflow-y-auto"><ul className="tw-flex tw-flex-col tw-px-2 tw-mx-0 tw-mb-0 tw-list-none">{filteredMemes.map(meme_1 => <li onClick={() => setMemeAndCloseDropdown(meme_1)} key={meme_1.id} className="tw-group tw-text-iron-50 tw-rounded-lg tw-relative tw-cursor-pointer tw-select-none tw-p-2 hover:tw-bg-iron-700 tw-transition tw-duration-300 tw-ease-out"><img src={meme_1.thumbnail ?? meme_1.image ?? meme_1.scaled ?? ""} alt="" className="tw-flex-shrink-0 tw-ml-0 tw-pl-0 tw-rounded-full tw-bg-iron-700 tw-h-6 tw-w-6" /><span className="tw-inline-block tw-ml-2 tw-text-sm tw-font-medium tw-text-iron-50">{`#${meme_1.id} ${meme_1.name ?? ""}`}</span></li>)}</ul></div></div></motion.div>;
    $[15] = filteredMemes;
    $[16] = isOpen;
    $[17] = setMemeAndCloseDropdown;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11) {
    t12 = <AnimatePresence mode="wait" initial={false}>{t11}</AnimatePresence>;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t10 || $[22] !== t12) {
    t13 = <div ref={listRef} className="tw-max-w-full tw-relative">{t5}{t10}{t12}</div>;
    $[21] = t10;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  return t13;
}